export const ROOT = '/sites';
export const MODULE = 'SITES';
